<!-- 商户订单/商户订单列表 -->
<template>
  <el-table :data="tableData" style="width: 100%;border: 1px solid #f1f1f1">
    <el-table-column
      sortable
      label="编号"
      align="center"
      prop="id"
      width="80"
    ></el-table-column>
    <el-table-column label="商品名称" align="center" min-width="150px">
      <template slot-scope="scope">
        <div class="img_info">
          <div class="img_box">
            <img :src="scope.row.image_url" alt="" />
          </div>
          <div class="info_box">
            <div class="info_line">{{ scope.row.cname }}</div>
            <div class="info_line">
              <span>品牌：{{ scope.row.pp }}</span>
            </div>
          </div>
        </div>
      </template>
    </el-table-column>
    <el-table-column label="商户" prop="name" align="center"></el-table-column>
    <el-table-column label="供货方" prop="ghf" align="center"></el-table-column>
    <el-table-column label="价格" prop="price" align="center"></el-table-column>
    <el-table-column label="状态" align="center">
      <template slot-scope="scope">
        <div class="table_scope_line">
          上架：<el-switch v-model="scope.row.is_sj"></el-switch>
        </div>
        <div class="table_scope_line">
          推荐：<el-switch v-model="scope.row.is_tj"></el-switch>
        </div>
      </template>
    </el-table-column>
    <el-table-column
      label="审核状态"
      prop="status"
      align="center"
    ></el-table-column>
    <el-table-column
      label="库存"
      prop="inventory"
      align="center"
    ></el-table-column>
    <el-table-column
      label="浏览次数"
      prop="looknum"
      align="center"
    ></el-table-column>
    <el-table-column label="排序" prop="sort" align="center"></el-table-column>
    <el-table-column label="操作" align="center">
      <template slot-scope="scope">
        <div class="table_button_line">
          <el-button type="text" @click="detail(scope.row.id)">查看</el-button>
        </div>
      </template>
    </el-table-column>
  </el-table>
</template>
<script>
export default {
  props: {
    tableData: {
      type: Array,
      default: function() {
        return [];
      }
    }
  },
  methods: {
    detail(id) {
      console.log(id);
    }
  }
};
</script>
<style lang="scss" scoped>
.img_info {
  margin: 0 auto;
  .img_box {
    display: inline-block;
    width: 50px;
    height: 50px;
    img {
      width: 50px;
      height: 50px;
    }
  }
  .info_box {
    vertical-align: top;
    display: inline-block;
    text-align: left;
    margin-left: 6px;
    .info_line {
      height: 23px;
      line-height: 23px;
      font-size: 12px;
      span {
        color: #666;
      }
    }
  }
}
</style>
